/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { pmta } from '../util/HttpsClient'
import Table from './Table';
import { updateComponent, getFromJson } from '../util/Utils'
import PropTypes from 'prop-types';
import { LONG_REFRESH_INTERVAL } from '../constants'


function makeTableData(state) {
    return {
        columns: ['File', 'Date', 'Size', 'Download'],
        loggingFiles: {
            data: makeFiles(state, 'log'),
            title: "Logging Files"
        },
        acctFiles: {
            data: makeFiles(state, 'acct'),
            title: "Accounting Files"
        }
    }
}


function makeFiles(state, type) {
    let files = getFromJson(state, ['data', 'data', type, 'files'], [])
    return files.map((f) => {
        return [f.name, f.date, f.size, f.path]
    })
}


/**
 * Logs page of web monitor.
 */
export default class Logs extends Component {
    constructor(props) {
        super(props)
        this.refresh = this.refresh.bind(this)
        this.refreshInterval = this.refreshInterval.bind(this)
        this.formatLogPath = this.formatLogPath.bind(this)
        this.formatAcctPath = this.formatAcctPath.bind(this)
    }


    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    async componentDidMount() {
        this.props.setRefresh(this.refresh)
        this.props.setRefreshInterval(this.refreshInterval)
        this.refresh()
    }


    refresh() {
        updateComponent(this, '/logs')
    }


    refreshInterval() {
        return LONG_REFRESH_INTERVAL
    }



    /**
     * Formats the given size for readability.
     *
     * @param size
     *      what to format, in bytes.
     * @return
     *      human-readable size.
     */
    formatSize(size) {
        if (size < 1024) {
            return size
        }
        size /= 1024
        let suffix = 'K'
        if (size < 1024) {
            return Math.trunc(size) + suffix
        }
        size /= 1024
        suffix = 'M'
        if (size < 1024) {
            return Math.trunc(size) + suffix
        }
        size /= 1024
        suffix = 'G'
        return Math.trunc(size) + suffix
    }


    /**
     * Formats log file path.
     *
     * @param path
     *      full path of the file.
     * @return
     *      link to download the file.
     */
    formatLogPath(path) {
        return (
            <div>
                { this.makeDownloadLink('download', path) }
            </div>
        )
    }


    /**
     * Formats accounting file path.
     *
     * @param path
     *      full path of the file.
     * @return
     *      a link download the file.
     */
    formatAcctPath(path) {
        return this.makeDownloadLink('download', path)
    }


    /**
     * Makes link to download a file.
     *
     * @param label
     *      what to show the link as.
     * @param path
     *      path of file for which the link is desired.
     */
    makeDownloadLink(label, path) {
        let url = pmta.baseUrl() + '/getFile?file=' + encodeURIComponent(path)
        let target = '_self'
        return (
            <a href={url} target={target}>
                {label}
            </a>
        )
    }


    render() {
        let tables = makeTableData(this.state)
        let logPathFormatter = {
            Size: this.formatSize,
            Download: this.formatLogPath
        }

        let acctPathFormatter = {
            Size: this.formatSize,
            Download: this.formatAcctPath
        }

        return (
            <Container>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.columns}
                               data={tables.loggingFiles.data}
                               caption={tables.loggingFiles.title}
                               columnFormatter={logPathFormatter}/>
                    }</Col>
                </Row>
                <Row>
                    <Col md={12}>{
                        <Table columns={tables.columns}
                               data={tables.acctFiles.data}
                               caption={tables.acctFiles.title}
                               columnFormatter={acctPathFormatter}/>
                    }</Col>
                </Row>
            </Container>
        );
    }
}
